import { connect } from "react-redux"
import makeStyles from "@material-ui/core/styles/makeStyles"

import Box from "@material-ui/core/Box"

const useStyles = makeStyles(theme => ({
    root: {
        height: 55,

        position: "fixed",
        left: 0,
        width: "100%",
        overflow: "hidden",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        backgroundColor: `${theme.palette.grey[100]} !important`,
        zIndex: 2
    }
}))

const AdminActionContainer = props => {
    const { children } = props
    const classes = useStyles()

    return (
        <Box
            className={classes.root}
            style={{
                bottom: 0
            }}
        >
            {children}
        </Box>
    )
}

function mapStateToProps(state) {
    return {
        toolbarHeight: state.app.toolbarHeight
    }
}

export default connect(mapStateToProps)(AdminActionContainer)
